// @flow

import React, {PureComponent} from 'react';
import { SectionChild } from '../components/section';

type Props = {
  children: React.Children,
  source: string,
  _parent: string
};

const getValidURL = (url) => {
  return !url ? undefined : new URL(url).toString();
};

export default class extends PureComponent<void, Props, void> {
  static _type = 'Link';
  _type = 'Link';

  render() {
    const {children, source} = this.props;

    return (
      <SectionChild>
        <a href={getValidURL(source)} className="external link" target="_blank">
          {children}
        </a>
      </SectionChild>
    );
  }
}



// WEBPACK FOOTER //
// ./src/fitbit-components/link.js